import { Button, Typography, useTheme } from "@mui/material";
import { BarChart3 } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CenteredIconState } from "web_myplann/Shared/Components/CenteredIconState";

type Props = {
	onStart: () => void;
};

export const FinancesEmptyState: FC<Props> = ({ onStart }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<CenteredIconState
			icon={BarChart3}
			iconBg={theme.palette.blue[100]}
			iconColor={theme.palette.blue[500]}
		>
			<Typography variant="h3" component="h2" mb={theme.spacingTokens.sm}>
				{t(Resources.Finances.Empty.title)}
			</Typography>
			<Typography variant="body2" mb={theme.spacingTokens.xxl}>
				{t(Resources.Finances.Empty.description)}
			</Typography>
			<Button variant="primary" onClick={onStart}>
				{t(Resources.Finances.Empty.button)}
			</Button>
		</CenteredIconState>
	);
};
